<template>
	<div
		class="g-block-pay-jumplink-advance"
		:class="{
			'g-block-pay-jumplink-advance--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-advance--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-advance__card" :style="cardStyle">
			<div class="g-block-pay-jumplink-advance__badge">
				<span class="g-block-pay-jumplink-advance__badge-icon">
					<i class="mbm-iconfont mbm-sijiaoxing"></i>
				</span>
				<span>{{ data.badgeText || '实战进阶课' }}</span>
			</div>
			<p class="g-block-pay-jumplink-advance__title">{{ data.title || 'ChatGPT' }}</p>
			<p class="g-block-pay-jumplink-advance__title-line2">{{ data.titleLine2 || '变现实战课' }}</p>
			<p class="g-block-pay-jumplink-advance__subtitle">{{ data.subtitle || '支付后跳转进入课程页面' }}</p>
			<div v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-advance__price">
				<span class="g-block-pay-jumplink-advance__currency">¥</span>
				<span class="g-block-pay-jumplink-advance__integer">{{ priceParts.integer }}</span>
				<span class="g-block-pay-jumplink-advance__decimal">{{ priceParts.decimal }}</span>
			</div>
			<div class="g-block-pay-jumplink-advance__features">
				<template v-for="(item, index) in displayFeatures" :key="index">
					<div class="g-block-pay-jumplink-advance__feature">
						<span class="g-block-pay-jumplink-advance__feature-icon">
							<i :class="['mbm-iconfont', item.iconClass]"></i>
						</span>
						<div class="g-block-pay-jumplink-advance__feature-text">
							<p class="g-block-pay-jumplink-advance__feature-title">{{ item.title }}</p>
							<p class="g-block-pay-jumplink-advance__feature-sub">{{ item.subtitle }}</p>
						</div>
					</div>
					<span
						v-if="index < displayFeatures.length - 1"
						class="g-block-pay-jumplink-advance__feature-divider"
					></span>
				</template>
			</div>
			<div
				class="g-block-pay-jumplink-advance__btn"
				@click.stop="onButtonClick"
			>
				<span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '立即学习' }}</span>
				<i class="mbm-iconfont mbm-youjiantou1"></i>
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { resolveGeditDemoImageUrl } from '../../../utils/localAssets.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_ADVANCE } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkAdvance',
		mixins: [payUnlockMixin],
		computed: {
			cardStyle() {
				const bg = this.resolveImageUrl(this.data.bgImage || DEFAULT_PAY_UNLOCK_JUMPLINK_ADVANCE.bgImage);
				return {
					backgroundImage: bg ? `url(${bg})` : 'none',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_ADVANCE.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
			displayFeatures() {
				const defaults = DEFAULT_PAY_UNLOCK_JUMPLINK_ADVANCE.features || [];
				const list = Array.isArray(this.data.features) && this.data.features.length
					? this.data.features
					: defaults;
				return list.map((item, index) => {
					const fallback = defaults[index] || {};
					return {
						title: item.title || fallback.title || '',
						subtitle: item.subtitle || fallback.subtitle || '',
						iconClass: item.iconClass || fallback.iconClass || 'mbm-sijiaoxing',
					};
				});
			},
		},
		methods: {
			resolveImageUrl(url) {
				return resolveGeditDemoImageUrl(url);
			},
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkAdvance: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-advance {
		&--edit {
			border: 1px solid transparent;
			border-radius: 16px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&__card {
			position: relative;
			overflow: hidden;
			background-size: cover;
			background-position: center right;
			background-repeat: no-repeat;
			color: #fff;
		}

		&__badge {
			display: inline-flex;
			align-items: center;
			border-radius: 999px;
			background: #3272fc;
			color: #fff;
			line-height: 1.2;
		}

		&__badge-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;

			.mbm-iconfont {
				color: #fff;
			}
		}

		&__title {
			margin: 0;
			font-weight: 700;
			line-height: 1.25;
			color: #1e3351;
		}

		&__title-line2 {
			margin: 0;
			font-weight: 700;
			line-height: 1.25;
			color: #1e3351;
		}

		&__subtitle {
			margin: 0;
			line-height: 1.4;
			color: #838fa2;
		}

		&__price {
			display: inline-flex;
			align-items: flex-end;
			font-weight: 700;
			line-height: 1;
		}

		&__currency,
		&__integer,
		&__decimal {
			color: #2a6efc;
			-webkit-background-clip: text;
			background-clip: text;
		}

		&__features {
			display: flex;
			align-items: center;
			justify-content: space-between;
			min-width: 0;
		}

		&__feature {
			display: flex;
			align-items: center;
			min-width: 0;
		}

		&__feature-divider {
			flex-shrink: 0;
			align-self: stretch;
			width: 1px;
			margin: 2px 0;
			background: rgba(255, 255, 255, 0.1);
		}

		&__feature-icon {
			flex-shrink: 0;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			background:#dae2f1;
		}

		&__feature-text {
			min-width: 0;
		}

		&__feature-title {
			margin: 0;
			font-weight: 600;
			color: #1e3351;
			white-space: nowrap;
		}

		&__feature-sub {
			margin: 0;
			color: #838fa2;
			white-space: nowrap;
		}

		&__btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			box-sizing: border-box;
			background: linear-gradient( 164deg, #493dff 0%, #3b82f6 100%);
			color: #fff;
			font-weight: 600;
			line-height: 1;
			cursor: pointer;
			user-select: none;
			box-shadow: 0 6px 18px rgba(85, 114, 235, 0.16);
		}

		/* ========== 左侧组件库预览 ========== */
		&:not(&--edit):not(&--h5) {
			.g-block-pay-jumplink-advance__card {
				border-radius: 14px;
				padding: 28px 14px 36px;
				box-shadow: 0 0px 16px rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-advance__badge {
				gap: 4px;
				padding: 4px 10px 4px 4px;
				font-size: 12px;
			}

			.g-block-pay-jumplink-advance__badge-icon {
				width: 18px;
				height: 18px;

				.mbm-iconfont {
					font-size: 14px;
				}
			}

			.g-block-pay-jumplink-advance__title {
				margin-top: 14px;
				font-size: 50px;
			}

			.g-block-pay-jumplink-advance__title-line2 {
				margin-top: 2px;
				font-size: 40px;
			}

			.g-block-pay-jumplink-advance__subtitle {
				margin-top: 8px;
				font-size: 15px;
			}

			.g-block-pay-jumplink-advance__price {
				margin-top: 18px;
			}

			.g-block-pay-jumplink-advance__currency {
				font-size: 40px;
				margin-right: 4px;
				margin-top: 8px;
			}

			.g-block-pay-jumplink-advance__integer {
				font-size: 80px;
			}

			.g-block-pay-jumplink-advance__decimal {
				font-size: 40px;
				margin-top: 6px;
			}

			.g-block-pay-jumplink-advance__features {
				gap: 0;
				margin-top: 28px;
			}

			.g-block-pay-jumplink-advance__feature {
				gap: 5px;
			}

			.g-block-pay-jumplink-advance__feature-icon {
				width: 35px;
				height: 35px;

				.mbm-iconfont {
					font-size: 18px;
					color: #2a6efc;
				}
			}

			.g-block-pay-jumplink-advance__feature-title {
				font-size: 11px;
				line-height: 1.25;
			}

			.g-block-pay-jumplink-advance__feature-sub {
				margin-top: 2px;
				font-size: 9px;
				line-height: 1.25;
			}

			.g-block-pay-jumplink-advance__btn {
				gap: 4px;
				margin-top: 22px;
				padding: 22px 14px;
				border-radius: 15px;
				font-size: 26px;

				.mbm-iconfont {
					font-size: 32px;
				}
			}
		}

		/* ========== 中间编辑区 ========== */
		&--edit {
			.g-block-pay-jumplink-advance__card {
				border-radius: 20px;
				padding: 30px 22px 40px;
				box-shadow: 0 0px 16px rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-advance__badge {
				gap: 4px;
				padding: 5px 10px 5px 5px;
				font-size: 13px;
			}

			.g-block-pay-jumplink-advance__badge-icon {
				width: 24px;
				height: 24px;

				.mbm-iconfont {
					font-size: 14px;
				}
			}

			.g-block-pay-jumplink-advance__title {
				margin-top: 20px;
				font-size: 70px;
			}

			.g-block-pay-jumplink-advance__title-line2 {
				margin-top: 4px;
				font-size: 56px;
			}

			.g-block-pay-jumplink-advance__subtitle {
				margin-top: 10px;
				font-size: 21px;
			}

			.g-block-pay-jumplink-advance__price {
				margin-top: 28px;
			}

			.g-block-pay-jumplink-advance__currency {
				font-size: 55px;
				margin-right: 6px;
				margin-top: 14px;
			}

			.g-block-pay-jumplink-advance__integer {
				font-size: 110px;
			}

			.g-block-pay-jumplink-advance__decimal {
				font-size: 55px;
				margin-top: 10px;
			}

			.g-block-pay-jumplink-advance__features {
				gap: 0;
				margin-top: 40px;
			}

			.g-block-pay-jumplink-advance__feature {
				gap: 10px;
			}

			.g-block-pay-jumplink-advance__feature-icon {
				width: 37px;
				height: 37px;

				.mbm-iconfont {
					font-size: 19px;
					color: #2a6efc;
				}
			}

			.g-block-pay-jumplink-advance__feature-title {
				font-size: 14px;
				line-height: 1.3;
			}

			.g-block-pay-jumplink-advance__feature-sub {
				margin-top: 3px;
				font-size: 12px;
				line-height: 1.3;
			}

			.g-block-pay-jumplink-advance__btn {
				gap: 6px;
				margin-top: 28px;
				padding: 28px 18px;
				border-radius: 17px;
				font-size: 32px;

				.mbm-iconfont {
					font-size: 40px;
				}
			}
		}

		/* ========== H5 ========== */
		&--h5 {
			.g-block-pay-jumplink-advance__card {
				border-radius: 0.4rem;
				padding: 0.56rem 0.28rem 0.72rem;
				box-shadow: 0 0 0.32rem rgba(0, 0, 0, 0.1);
			}

			.g-block-pay-jumplink-advance__badge {
				gap: 0.08rem;
				padding: 0.1rem 0.2rem 0.1rem 0.1rem;
				font-size: 0.24rem;
			}

			.g-block-pay-jumplink-advance__badge-icon {
				width: 0.48rem;
				height: 0.48rem;

				.mbm-iconfont {
					font-size: 0.28rem;
				}
			}

			.g-block-pay-jumplink-advance__title {
				margin-top: 0.4rem;
				font-size: 1rem;
			}

			.g-block-pay-jumplink-advance__title-line2 {
				margin-top: 0.08rem;
				font-size: 0.8rem;
			}

			.g-block-pay-jumplink-advance__subtitle {
				margin-top: 0.2rem;
				font-size: 0.3rem;
			}

			.g-block-pay-jumplink-advance__price {
				margin-top: 0.56rem;
			}

			.g-block-pay-jumplink-advance__currency {
				font-size: 0.8rem;
				margin-right: 0.08rem;
				margin-top: 0.28rem;
			}

			.g-block-pay-jumplink-advance__integer {
				font-size: 1.6rem;
			}

			.g-block-pay-jumplink-advance__decimal {
				font-size: 0.8rem;
				margin-top: 0.2rem;
			}

			.g-block-pay-jumplink-advance__features {
				gap: 0;
				margin-top: 0.8rem;
			}

			.g-block-pay-jumplink-advance__feature {
				gap: 0.10rem;
			}

			.g-block-pay-jumplink-advance__feature-icon {
				width: 0.7rem;
				height: 0.7rem;

				.mbm-iconfont {
					font-size: 0.36rem;
					color: #2a6efc;
				}
			}

			.g-block-pay-jumplink-advance__feature-title {
				font-size: 0.22rem;
				line-height: 1.3;
			}

			.g-block-pay-jumplink-advance__feature-sub {
				margin-top: 0.04rem;
				font-size: 0.18rem;
				line-height: 1.3;
			}

			.g-block-pay-jumplink-advance__btn {
				gap: 0.12rem;
				margin-top: 0.56rem;
				padding: 0.44rem 0.28rem;
				border-radius: 0.18rem;
				font-size: 0.52rem;

				.mbm-iconfont {
					font-size: 0.7rem;
				}
			}
		}
	}
</style>
